<template>
  <div class="gate-container">
    <div
      class="flex-between"
      style="position: absolute; right: 12px; top: -35px; padding: 0 10px"
    >
      <div style="width: 100%; display: flex">
        <label class="scene-label">出入口：</label>
        <el-select
          style="flex: 1"
          placeholder="请选择出入口"
          v-model="sceneList"
          @change="queryDeviceSceneDetail"
        >
          <el-option
            v-for="item in list"
            :key="item.sceneCode"
            :label="item.sceneName"
            :value="item.sceneCode"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <range-control ref="rangeControl" style="margin-top:12px"></range-control>
  </div>
</template>
<script>
import { Dic } from "$utils";
import rangeControl from "@/modules/gatewayManager/components/rangeControl";
import { api } from "../api";
export default {
  name: "gate-control",
  components: { rangeControl },
  props: {},
  data() {
    return {
      list: [],
      sceneList: [],
      // 页面展示道闸列表
      gateList: [],
      openImg: require("@/common/assets/images/getway-open.png"),
      closeImg: require("@/common/assets/images/getway-close.png"),
      enterColor: "#00CCCC",
      exitColor: "#FF6600",

      sceneDetailList: [],
      sceneDetailList2: [],
      sceneGateList: [],
      thirdDeviceIdList: [],
    };
  },
  created() {},
  mounted() {
    this.getDeviceSceneList();
  },

  beforeDestroy() {},
  methods: {
    // 获取设备场景列表
    getDeviceSceneList() {
      this.$fetch(api.reserveProcess.queryDeviceSceneList, {
        sceneType: "1",
        sceneName: "",
        pageNum: 1,
        pageSize: 1000,
      }).then((res) => {
        if (res.success) {
          this.list = (res.returnObj && res.returnObj.list) || [];
          let currentItem = null;
          if (this.list && this.list.length) {
            currentItem = this.list.find((item) => {
              return item.sceneCode === this.currentCode;
            });
            currentItem = currentItem || this.list[0];
          }
        }
      });
    },
    // 根据场景查询对应的道闸
    queryDeviceSceneDetail(code) {
      console.log("queryDeviceSceneDetail---start", code);
      this.$nextTick(() => {
        this.$fetch(api.reserveProcess.queryDeviceSceneDetail, {
          sceneCode: code,
        }).then((res) => {
          if (res.success) {
            let result = res.returnObj || {};
            this.$refs.rangeControl.handleOpen(result);
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

:deep .list-content {
  width: 250px;
  background: rgba(#ffffff, 0.5);
  // @include set_theme_color(background-color, map-panel);
}
.gate-container {
  display: flex;
  flex-direction: column;
  height: calc(100% - 20px);
  .scene-label {
    width: 60px;
    line-height: 32px;
  }
}
</style>
